/**
 * A count as the screens print it: «1.204», never «1204».
 *
 * es-ES leaves four-digit numbers ungrouped by default (CLDR's «min2» rule), so a column of
 * counts reads «999 · 1204 · 12.040» and the eye stops trusting the digits. `always` groups
 * from the thousands, which is what a table of counts needs to line up.
 *
 * A missing count prints as a dash rather than «0»: nothing read and nothing there are
 * different answers, and the screens must not merge them.
 */
const COUNT = new Intl.NumberFormat('es-ES', {
  // The ES2022 lib types this option as boolean; the runtime (and ES2023's lib) accept 'always'.
  useGrouping: 'always' as unknown as boolean,
});

const MISSING = '—';

export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return MISSING;
  return COUNT.format(value);
}
